<template>
  <span fluid>
    <v-card class="card--flex-toolbar">
      <v-card-title class="blue-grey lighten-5">
        <h2>Cadastro de Profissionais para Veículos</h2>
        <v-spacer></v-spacer>
        <v-btn @click="onNewButtonClick()" small color="primary">Novo</v-btn>
      </v-card-title>
      <v-card-text>
        <e-data-table
          :headers="headers"
          :items="up"
          :total="total"
          :hideSearch="true"
          @refresh="getAll"
          @delete="deleteItem"
        ></e-data-table>
      </v-card-text>
      <v-card-actions></v-card-actions>
    </v-card>
  </span>
</template>
<script>
import profissionalveiculosService from '@/services/profissionalveiculos'
import EDataTable from '@/components/EDataTable'
import { showError, showConfirm, retPermissao } from '@/utils'
// import profissionalService from '@/services/profissional'

export default {
  name: 'profissionalveiculos',
  components: {
    EDataTable
  },
  data () {
    return {
      up: [],
      total: 0,
      headers: [
        { text: 'Profissional', value: 'profissional', sortable: false },
        { text: 'Veículo', value: 'veiculo', sortable: false }],
      valid: true,
      buttonSaveLoadingVisible: false
    }
  },

  methods: {
    async getAll (page, search) {
      try {
        this.loading = true
        const result = search === '' ? await profissionalveiculosService.getAll(page) : await profissionalveiculosService.getByNome(search, page)
        this.total = result._meta.total_items
        this.up = result.data
        this.loading = false
      } catch (error) {
        this.viagens = []
        showError(error)
      }
    },
    // editItem (item) {
    // var ret = retPermissao('Profissionais Veículos', 'alterar')
    // if (ret === true) {
    // this.$router.push(`/profissionaisveiculos/editar/${item.id}`)
    // }
    // },
    async deleteItem (item) {
      var ret = retPermissao('Profissionais Veículos', 'excluir')
      if (ret === true) {
        showConfirm(`Tem certeza que deseja remover relacionamento ?`, async result => {
          if (result) {
            try {
              this.loading = true
              await profissionalveiculosService.delete(item.id)
              this.getAll(1, '')
            } catch (error) {
              showError(error)
            } finally {
              this.loading = false
            }
          }
        })
      }
    },
    onNewButtonClick () {
      var ret = retPermissao('Profissionais Veículos', 'incluir')
      if (ret === true) {
        this.$router.push(`/profissionaisveiculos/criar`)
      }
    }
  }
}
</script>
